import Button from '@/Components/Button';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import { ScheduleTypeForm, ScheduleTypeResults } from '@/Components/BranchOffice/ScheduleTypeForm';
import { Head, useForm } from '@inertiajs/inertia-react';
import date from '@/helpers/date';
import Authenticated from '@/Layouts/Authenticated';
import ValidationErrors from '@/Components/ValidationErrors';
import Select from 'react-select';
import { useEffect, useRef, useState } from 'react';
import ImageSelector from '@/Components/ImageSelector';
import "cropperjs/dist/cropper.css";
import Switch from '@/Components/Switch';

const Edit = ({ store, branchOffice, ...props }) => {

    const { data, setData, processing, post } = useForm({
        'name': branchOffice.name,
        'email': branchOffice.email,
        'address': branchOffice.address,
        'telephone': branchOffice.telephone,
        'schedule_title': branchOffice.schedule_title,
        'schedule_description': branchOffice.schedule_description,
        'class_limit': branchOffice.class_limit,
        'quota': branchOffice.quota,
        'birthday_limit': branchOffice.birthday_limit,
        'users': branchOffice.users,
        'softland_id': branchOffice.softland_id,
        'softland_cost_center': branchOffice.softland_cost_center,
        'img': branchOffice.img,
        'is_active': branchOffice.is_active,
        'class_limit_monthly': branchOffice.class_limit_monthly
    });

    const [image, setImage] = useState();
    const [previewImage, setPreviewImage] = useState('')
    const [isOpenImageSelector, setIsOpenImageSelector] = useState(false);

    const inputImageFileRef = useRef(null);

    const handleFile = (e) => {
        if (e.currentTarget.files) {
            setPreviewImage(URL.createObjectURL(e.target.files[0]));
            setIsOpenImageSelector(true);
            setImage(e.target.files[0]);
            setData('img', e.target.files[0]);
        }
    };

    useEffect(() => {
        setData('img', image);
    }, [image])

    const handleOpenImageSelector = () => {
        inputImageFileRef.current.value = null;
        inputImageFileRef.current.click();
    }

    const [users, setUsers] = useState(branchOffice.users.map(user => ({ label: user.name, value: user.id })))
    const [isScheduleFormVisible, setIsScheduleFormVisible] = useState(false)

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const submit = (event) => {
        event.preventDefault();

        post(route('branch-office.update', branchOffice.slug), { forceFormData: true });
    }

    useEffect(() => {
        setData('users', users ? users.map(user => user.value) : [])
    }, [users])

    const showScheduleForm = ()=> {
        setIsScheduleFormVisible(! isScheduleFormVisible)
    }

    return (
        <Authenticated
            branchOffice={branchOffice}
            store={store}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Editar sucursal</h2>}
        >

            <Head title={`Editar sucursal - ${store === 'cerogrado' ? 'Cerogrado' : 'Trampoline Park'}`} />

            <ValidationErrors errors={props.errors} />
            <form onSubmit={submit} className="p-4 mt-8 max-w-3xl mx-auto" encType="multipart/form-data">
                <div className="inline-flex flex-col justify-center items-center">
                    <ImageSelector
                        open={isOpenImageSelector}
                        setOpen={setIsOpenImageSelector}
                        image={image}
                        previewImage={previewImage}
                        setImage={setImage}
                        setPreviewImage={setPreviewImage}
                        cropperWidth={300}
                        cropperHeight={150}
                    />
                    <input
                        type="file"
                        name="img"
                        id="img-input"
                        className="hidden"
                        onChange={handleFile}
                        ref={inputImageFileRef}
                    />
                    <div onClick={handleOpenImageSelector} className="border border-gray-300 cursor-pointer overflow-hidden relative mb-4" style={{ width: 300, height: 150 }}>
                        <img onError={(event) => event.target.src = '/images/placeholder-rectangle.jpeg'} className="absolute w-full h-full top-0 left-0" src={previewImage || branchOffice.img || '/images/placeholder-rectangle.jpeg'}  />
                    </div>
                    <Button type="button" onClick={handleOpenImageSelector} className="cursor-pointer">Subir imagen</Button>
                </div>
                <div className="grid grid-cols-1 w-full gap-4 mb-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <Label forInput="name" value="Nombre de la sucursal" />
                            <Input
                                name="name"
                                handleChange={onHandleChange}
                                value={data.name}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="email" value="Correo electronico de la sucursal" />
                            <Input
                                name="email"
                                handleChange={onHandleChange}
                                value={data.email}
                                type="text"
                                className="w-full"
                                disabled={true}
                            />
                        </div>
                        <div>
                            <Label forInput="softland_id" value="Softland Bodega" />
                            <Input
                                name="softland_id"
                                handleChange={onHandleChange}
                                value={data.softland_id}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <Label forInput="address" value="Direccion de la sucursal" />
                            <Input
                                name="address"
                                handleChange={onHandleChange}
                                value={data.address}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="telephone" value="Telefono de la sucursal" />
                            <Input
                                name="telephone"
                                handleChange={onHandleChange}
                                value={data.telephone}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="softland_cost_center" value="Softland Centro de costos" />
                            <Input
                                name="softland_cost_center"
                                handleChange={onHandleChange}
                                value={data.softland_cost_center}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <Label forInput="schedule_title" value="Titulo horario pista" />
                            <Input
                                name="schedule_title"
                                handleChange={onHandleChange}
                                value={data.schedule_title}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="schedule_description" value="Descripcion horario pista" />
                            <Input
                                name="schedule_description"
                                handleChange={onHandleChange}
                                value={data.schedule_description}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                        {/* <div>
                            <Label forInput="admin_id" value="Administrador" />
                            <Select
                                id="admin_id"
                                styles={{
                                    indicatorSeparator: () => ({ display: "none" }),
                                    input: (styles) => ({
                                        ...styles,
                                        "> input": {
                                            boxShadow: "none !important",
                                        },
                                    }),
                                }}
                                className="rounded-md shadow-none"
                                options={props.admins.map(admin => {
                                    return {
                                        value: admin.id,
                                        label: admin.name
                                    }
                                })}
                                value={
                                    data.admin_id && Boolean(props.admins.length)
                                        ? {
                                            value: data.admin_id,
                                            label: props.admins.find(({ id }) => id === data.admin_id).name,
                                        }
                                        : {
                                            value: null,
                                            label: "Seleccione un administrador",
                                        }
                                }
                                noOptionsMessage={() =>
                                    "No hay administradores en el sistema"
                                }
                                onChange={(value) => handleSelect(value)}
                            />
                        </div> */}

                        <div className="md:col-span-3">
                            <Label forInput="class_limit" value="Aforo de clases diaria" />
                            <Input
                                name="class_limit"
                                handleChange={onHandleChange}
                                value={data.class_limit}
                                type="text"
                                className="w-full"
                            />
                        </div>

                        <div className="md:col-span-3">
                            <Label forInput="class_limit_monthly" value="Aforo de clases mensual" />
                            <Input
                                name="class_limit_monthly"
                                handleChange={onHandleChange}
                                value={data.class_limit_monthly}
                                type="text"
                                className="w-full"
                            />
                        </div>

                        <div className="md:col-span-3">
                            <Label forInput="quota" value="Aforo general" />
                            <Input
                                name="quota"
                                handleChange={onHandleChange}
                                value={data.quota}
                                type="text"
                                className="w-full"
                            />
                        </div>

                        <div className="md:col-span-3">
                            <Label forInput="birthday_limit" value="Aforo cumpleaños" />
                            <Input
                                name="birthday_limit"
                                handleChange={onHandleChange}
                                value={data.birthday_limit}
                                type="text"
                                className="w-full"
                            />
                        </div>

                        <div className="md:col-span-12">
                            <Label forInput="users" value="Trabajadores" />
                            <Select
                                options={props.users.map(user => ({label: user.name, value: user.id}))}
                                isMulti
                                isClearable
                                //menuIsOpen={false}
                                id="users"
                                styles={{
                                    indicatorSeparator: () => ({ display: "none" }),
                                    input: (styles) => ({
                                        ...styles,
                                        "> input": {
                                            boxShadow: "none !important",
                                        },
                                    }),
                                }}
                                className="col-span-8 rounded-md shadow-none"
                                //onKeyDown={handleKeyDown}
                                //onInputChange={(newValue) => setSelectInputValue(newValue)}
                                onChange={(newValue) => {
                                    setUsers(users => [...newValue])
                                }}
                                value={ users }
                                placeholder="Selecciona los trabajadores."
                                noOptionsMessage={() =>
                                    "No hay trabajadores para asignar"
                                }
                            />
                        </div>

                    </div>
                </div>
                <Button processing={processing}>Guardar</Button>
            </form>
            <div className="p-4 mt-8 max-w-3xl mx-auto">
                <div className="flex justify-between">
                    <h2>Periodos de agendamiento</h2>
                    <Button className="bg-black text-white"
                        onClick={showScheduleForm}
                    >Agregar periodo</Button>
                </div>
                {
                isScheduleFormVisible &&
                <ScheduleTypeForm branchOffice={branchOffice}/>
                }
                <ScheduleTypeResults branchOfficeSlug={branchOffice.slug} scheduleTypes={branchOffice.schedule_types} />
            </div>
        </Authenticated>
    )
}

export default Edit;
